<div class="userbox" fxFlex *ngIf="showUserBox$ | async">
  <div
    *ngIf="!user; else loggedinFlyout"
    fxFlex
    [ngClass]="{
      userbox__nologin: true,
      'userbox__nologin--desktop': !isMobileView,
      'userbox__nologin--mobile': isMobileView
    }"
    role="presentation"
    aria-live="polite"
  >
    <app-account-flyout-context
      (accountFlyoutClicked)="handleLogin()"
    ></app-account-flyout-context>
  </div>

  <ng-template #loggedinFlyout>
    <ng-container *ngIf="isWebFlyoutEnabled$ | async; else failoverFlyout">
      <cms-user-profile aria-label="User profile menu" role="menu">
        <div>
          <div className="">
            <div slot="user-icon" data-hj-suppress aria-hidden="true"></div>
            <div className="">
              <div slot="user-name" data-hj-suppress aria-label="User name"></div>
              <div slot="user-business" data-hj-suppress aria-label="User business"></div>
            </div>
          </div>
        </div>
      </cms-user-profile>
    </ng-container>
    <ng-template #failoverFlyout>
      <ng-container *ngIf="(isWebFlyoutEnabled$ | async) === false">
        <app-account-flyout-failover
          [user]="user"
          [isMobileView]="isMobileView"
          aria-label="User account menu"
          role="menu"
        ></app-account-flyout-failover>
      </ng-container>
    </ng-template>
  </ng-template>
  <aside
    *ngIf="isMobile"
    class="account-dropdown"
    [ngClass]="isUserMenuOpened ? 'account-dropdown__open' : 'account-dropdown__close'"
    role="menu"
    aria-label="Account dropdown"
    [attr.aria-expanded]="isUserMenuOpened"
  >
    <app-account-dropdown
      [isMobile]="isMobile"
      [userData]="user"
      (closeSlideMenu)="closeMobileMenu()"
      aria-label="Account options"
      role="menuitem"
    ></app-account-dropdown>
  </aside>
</div>
<div
  class="account-dropdown__overlay"
  *ngIf="isUserMenuOpened"
  tabindex="0"
  aria-label="Close account dropdown overlay"
  role="button"
></div>
